import React from 'react'
import {AppBar, Toolbar, withStyles, Grid} from '@material-ui/core'
import favicon from './favicon.ico'

const styles = theme => ({
    footer: {
        flexGrow: 1,
        fontSize: '1.25rem',
        textAlign: 'center',
        // paddingTop: 10,
        [theme.breakpoints.down('xs')]:{
            fontSize: '2.37vw',
        }
    },
    appBar: {
        backgroundColor: '#3A3A3A',
        padding: '10px 0px 40px 0px',
        margin: '0px !important',
        [theme.breakpoints.down('xs')]: {
            // paddingBottom: 10,
        }
    },
    link: {
        textDecoration: 'none',
        color: 'white',
        '&:hover': {
            color: '#b1aaaa',
            transition: 'none'
        }
    }
})

class Footer extends React.Component {
    render() {
        const {classes} = this.props
        return (
            <Grid container className={classes.footer}>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar style={{padding:8}}>
                        <Grid container justify={"center"} spacing={8}>
                            <Grid container item xs={12} justify={"center"} spacing={8}>
                                <Grid container justify={"center"} style={{paddingTop: 8}}>
                                    <Grid item xs={"auto"}>
                                        <img src={favicon} alt="favicon" width={35} height={35}/>
                                    </Grid>
                                </Grid>
                                <Grid item xs={"auto"}>
                                    Geniam
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} justify={"center"}>
                                <Grid item xs={"auto"}>
                                    Copyright (C) 2018 Invenstor .inc All Rights Reserved.
                                </Grid>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Grid>
        );
    }
}

export default withStyles(styles)(Footer)
